import '@/tools/jssdk/index.js'
import RUNUI from '@runwork/runui'
import '@runwork/runui/library/common.css'
import '@runwork/runui/library/runui.css'
// import vconsole from 'vconsole'
import VeeValidate, { Validator } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN'
import Vue from 'vue'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueQuillEditor from 'vue-quill-editor'
import Router from 'vue-router'
import App from './App.vue'
import './assets/icon/iconfont.css'
import Fullnav from './components/fullnav.vue'
import * as filters from './filters/index'
import router from './router.js'
import RunInit from './run.init.js'
import store from './store/index.js'
import './style/index.scss'

// if (~location.href.indexOf('console')) {
//   new vconsole()
// }

var options = {
  fullscreenEl: false, //关闭全屏按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: false
}
Vue.prototype.isRunwork = false
Vue.prototype.isPad = /iPad/i.test(navigator.userAgent)
Vue.prototype.platform =
  !!window.h5sdk || process.env.NODE_ENV === 'development' ? 3 : 2
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
  crhReady(() => {
    Vue.prototype.isRunwork = true
  })
}
Vue.prototype.$isHarmony = /OpenHarmony/i.test(navigator.userAgent);
Vue.use(VueQuillEditor)
Vue.use(preview, options)
// 覆盖原有提示
zh_CN.messages.between = (field, params) => {
  return `值超出范围`
}
Vue.use(VeeValidate, {
  dictionary: {
    zh_CN: zh_CN
  }
})
Vue.component('Fullnav', Fullnav)
Validator.localize('zh_CN')

//拓展的验证功能
Validator.extend('phone', {
  getMessage: field => '请输入正确的手机号码',
  validate: value => {
    return (
      /^1[1-9]\d{9}$/.test(value) ||
      /^[6|9]\d{7}$/.test(value) ||
      /^[09|9]\d{9}$/.test(value)
    )
    // return /^(1(3|4|5|7|8|9)\d{9})$|^([0-9]{8})$/.test(value)
  }
})

Validator.extend('email', {
  getMessage: field => '请输入正确的邮箱',
  validate: value => {
    return (
      /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
        value
      ) ||
      /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+(\.([a-zA-Z]{2,4}))+$/.test(value)
    )
  }
})

Validator.extend('ch', {
  getMessage: field => '请输入正确的中文',
  validate: value => {
    return /^[\u4E00-\u9FA5\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b,\.;\-_\?]*$/.test(
      value
    )
  }
})

Validator.extend('en', {
  getMessage: field => '请输入正确的字母',
  validate: value => {
    return /^[a-zA-Z\ \,\.\?\:\\\/\*\#\@\$\&\^\(\)\[\]\{\}\<\>\;\'\"\!\-\=\_\+\|\t]+$/.test(
      value
    )
  }
})

Validator.extend('number', {
  getMessage: (field, params, value) => {
    return `请填写数字`
  },
  validate: (value, params) => {
    return /^0|[1-9][0-9]*|[1-9]d*.d*|0.d*[1-9]d*$/.test(value)
  }
})
Validator.extend('max', {
  getMessage: (field, params, value) => {
    return `最多只能输入 ${params[0]} 字符，当前输入${params[1]}字符`
  },
  validate: (value, params) => {
    return value.length <= Number(params[0])
  }
})

Validator.extend('min', {
  getMessage: (field, params, value) => {
    return `至少输入${params[0]} 字符`
  },
  validate: (value, params) => {
    return value.length >= Number(params[0])
  }
})

Validator.extend('selectRangeMin', {
  getMessage: (field, params) => {
    if (params[0] === params[1]) {
      return `必须选择${params[1]}个选项`
    }
    return `请至少选择${params[0]}个选项`
  },
  validate: (value, param) => {
    return value.length >= Number(param[0])
  }
})

Validator.extend('selectRangeMax', {
  getMessage: (field, params) => {
    if (params[0] === params[1]) {
      return `必须选择${params[1]}个选项`
    }
    return `最多只能选择${params[1]}个选项`
  },
  validate: (value, params) => {
    return value.length <= Number(params[1])
  }
})

Vue.use(RUNUI, {
  dependence: {
    router,
    store
  }
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// import { RunWorkH5 } from '@runwork/runwork-help'
// Vue.use(RunWorkH5, {
//   env: process.env.VUE_APP_env,
//   isLocal: process.env.NODE_ENV === 'development',
//   appId: process.env.VUE_APP_appId,
//   devUser: 'tanghui',
//   isHrInfo: true
// })

// Vue.prototype.user = {}
// Vue.prototype.$nativeBridgeReady = function() {
//   return Vue.prototype.$runWorkH5.initReady().then(() => {
//     if (!Vue.prototype.user.userId) {
//       Vue.prototype.user.ldap = Vue.prototype.$runWorkH5.ldap
//     }
//     return Promise.resolve()
//   })
// }

setTimeout(() => {
  Vue.use(Router)

  new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      !!navigator.userAgent.match(/iphone/i) &&
        (document.body.className = 'webapp-device-ios')
      const url = location.href
      const path = location.hash.slice(1)
      if (url.includes('#/detail')) {
        this.$router.replace('/')
      }
      RunInit('gongyuan113')
      if (!url.includes('preview')) {
        if (url.includes('#/detail')) {
          this.$router.replace(path)
        } else {
          this.$router.replace('/home')
        }
        // .then(() => {
        //   if (url.includes('#/detail')) {
        //     this.$router.replace(path)
        //   } else {
        //     this.$router.replace('/home')
        //   }
        // })
      } else {
        this.$router.push(path)
      }
    }
  }).$mount('#app')
}, 500)
